import React, { useState, useEffect,useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button,Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function WriteBlog() {
    const { id } = useParams();
    const { blogid } = useParams(); // "new" or blogId
    console.log(blogid)
    const [isPublished, setIsPublished] = useState(true);


    const [content, setContent] = useState("");
    const quillRef = useRef(null);


    // Fetch existing blog content if editing
    // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
        if (id !== "new") {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/blogs/${blogid}`)
                .then((res) => res.json())
                .then((data) => {
  setContent(data.content || "");
  setIsPublished(Boolean(data.is_published));
})

                .catch(() => toast.error("Failed to load blog content"));
        }
    }, [blogid]);

  

    const submitBlog = async () => {
                const token = localStorage.getItem("MagazineToken")

const body = {
  content,
  isPublished
};
        const method = "PUT";

        const url =
            
                `${process.env.REACT_APP_BACKEND_URL}/api/blogs/add-content/${blogid}`
                // : `${process.env.REACT_APP_BACKEND_URL}/api/blogs/update-content/${blogid}`;

        try {
            const res = await fetch(url, {
                method,
           
                headers: { "Content-Type": "application/json",  Authorization: `Bearer ${token}`, },
                body: JSON.stringify(body),
            });

            if (!res.ok) throw new Error("Save failed");

            toast.success("Blog content saved successfully!");
            window.location.href = "/admin/blogs";
        } catch (err) {
            toast.error(err.message || "Failed to save blog");
        }
    };

    return (
        <div className="container py-3" style={{ maxWidth: "950px" }}>
            {/* Header */}
            <div className="mb-4">
                <h2 className="fw-bold text-dark mb-1" style={{ fontSize: "2rem" }}>
                    {id === "new" ? "Create Blog" : "Edit Blog"}
                </h2>
            </div>

            {/* Editor Container with subtle shadow and border */}
            <div
                className="border rounded-3 shadow-sm bg-white"
                style={{
                    overflow: "hidden",
                    borderColor: "#e2e8f0 !important",
                }}
            >
                <ReactQuill
                    theme="snow"
                    value={content}
                    ref={quillRef}
                    onChange={setContent}
                    modules={WriteBlog.modules}
                    formats={WriteBlog.formats}
                    placeholder="Start writing your blog post here..."
                    style={{
                        backgroundColor: "#ffffff",
                    }}
                />
            </div>

            {/* Custom styling for toolbar - cleaner look */}
            <style jsx global>{`
                .ql-container {
                    border: none !important;
                    font-size: 1.1rem;
                    font-family: 'Georgia', serif;
                }
                .ql-editor {
                    min-height: 420px;
                    padding: 2rem 2.5rem;
                    line-height: 1.8;
                    color: #2d3748;
                }
                .ql-editor.ql-blank::before {
                    color: #a0aec0;
                    font-style: italic;
                    left: 2.5rem;
                }
                .ql-toolbar {
                    border: none !important;
                    border-bottom: 1px solid #e2e8f0 !important;
                    background-color: #f8fafc;
                    padding: 12px 20px;
                    border-top-left-radius: 12px;
                    border-top-right-radius: 12px;
                }
                .ql-toolbar .ql-stroke {
                    stroke: #64748b;
                }
                .ql-toolbar .ql-fill {
                    fill: #64748b;
                }
                .ql-toolbar .ql-picker {
                    color: #475569;
                }
                .ql-toolbar button:hover,
                .ql-toolbar .ql-active,
                .ql-toolbar .ql-picker-label:hover,
                .ql-toolbar .ql-picker-item:hover {
                    color: #6d28d9 !important;
                }
                .ql-toolbar button:hover .ql-stroke,
                .ql-toolbar .ql-active .ql-stroke,
                .ql-toolbar button.ql-active .ql-fill,
                .ql-toolbar .ql-picker-label.ql-active .ql-stroke {
                    stroke: #6d28d9 !important;
                    fill: #6d28d9 !important;
                }
            `}</style>
                       <Form.Check
  type="checkbox"
  id="publishBlog"
  label="Publish this blog (visible on main website)"
  checked={isPublished}
  onChange={(e) => setIsPublished(e.target.checked)}
  className="mt-4 mb-3"
  style={{ fontSize: "1.05rem" }}
/>
            

            {/* Save Button */}
            <div className="mt-5 text-end">
     

                <Button
                    onClick={submitBlog}
                    size="lg"
                    className="px-5 shadow-sm fw-medium"
                    style={{
                        background: "linear-gradient(90deg, #6d28d9, #4c1d95)",
                        border: "none",
                        borderRadius: "12px",
                        padding: "12px 32px",
                        fontSize: "1.1rem",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
                    onMouseOut={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                >
                    Save Blog
                </Button>
            </div>
        </div>
    );
}

// Enhanced toolbar with better UX
WriteBlog.modules = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
    handlers: {
      image: function () {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "image/*");
        input.click();

        input.onchange = async () => {
          const file = input.files[0];
          const formData = new FormData();
          formData.append("image", file);
                const token = localStorage.getItem("MagazineToken")

          const res = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/blogs/upload-image`,
            {
              method: "POST",
                headers: {
        Authorization: `Bearer ${token}`,
        // Do NOT set Content-Type → browser sets correct boundary
      },
              body: formData,
            }
          );

          const data = await res.json();

          let quill = this.quill;
          const range = quill.getSelection();
          let url=`${process.env.REACT_APP_BACKEND_URL}${data.url}`
          quill.insertEmbed(range.index, "image", url);
        };
      },
    },
  },
};

WriteBlog.formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
];